export default [
  {
    type: 'cmd',
    label: '\\verb||',
    snippet: '\\verb|#{}|',
  },
]
